import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "6.5",
      cy: "12",
      r: "1.5",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "11.5",
      cy: "12",
      r: "1.5",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "16.5",
      cy: "12",
      r: "1.5",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render };